import React, {useEffect, useState} from 'react';
import Button from '../Button';
import './Vertical.scss'

const Vertical = (props) => {
    
    const { min, max, value, buttonText, onRangeChanged, callback } = props

    const [ rangeValue, setRangeValue ] = useState()

    useEffect( () => {
        setRangeValue(value ? value : min)
    }, [])

    const handleRangeValue = (e) =>{
        setRangeValue(e.target.value)
        if(onRangeChanged) onRangeChanged(e.target.value)
    }

    return (
        <div className="range-container">
            <div className="range-column input">
                <input orient='vertical' type="range" min={min} value={rangeValue ? rangeValue : 0 } max={max} onChange={handleRangeValue}/>
            </div>  
            <div className="range-column value">
                <div className="range-value">
                    {rangeValue ? rangeValue : 0}
                </div>
                {callback && <Button className='small primary' text={buttonText} onClickHandle={()=>callback(rangeValue)} /> }
            </div>
            
            
        </div>
    );
}
export default Vertical;